import { useFormikContext } from "formik";
import { FormFieldOption } from "../types";
import React from "react";
import flatten from "lodash/flatten";
export function ValidateSingleSelectedFormOption({
  options,
  value,
  name,
  fixedInitialValueOnReset
}: {
  options: FormFieldOption[];
  value: string;
  name: string;
  fixedInitialValueOnReset?: any;
}) {
  const isSelectedValuePresentInOptions = options.find(option => option.value === value)?.value && options.length > 0;
  const fixedValueRef = React.useRef(fixedInitialValueOnReset);
  if (isSelectedValuePresentInOptions || options?.length === 0 || !value) {
    return null;
  }

  return <ResetSelectedOption name={name} resetValue={fixedValueRef.current || ""} />;
}

export function ValidateMultiSelectedFormOption({
  options,
  values,
  name
}: {
  options: FormFieldOption[];
  values: Array<string>;
  name: string;
}) {
  const validOptions = options.filter(option => values?.includes?.(option.value)).map(option => option.value);
  const areAllSelectedValuesPresentInOptions = validOptions.length === values?.length;
  if (areAllSelectedValuesPresentInOptions || options?.length === 0 || values?.length === 0) {
    return null;
  }
  return <ResetSelectedOption name={name} resetValue={validOptions} />;
}

export function ValidateNestedMultiSelectFormOption({
  options,
  values,
  name
}: {
  options: FormFieldOption[];
  values: Array<string>;
  name: string;
}) {
  const childOptions = React.useMemo(() => {
    return flatten(options.map(option => option.childOptions || []));
  }, [options]);
  const validOptions = childOptions.filter(option => values?.includes?.(option.value)).map(option => option.value);
  const areAllSelectedValuesPresentInOptions = validOptions.length === values.length;
  if (areAllSelectedValuesPresentInOptions || childOptions?.length === 0 || values.length === 0) {
    return null;
  }
  return <ResetSelectedOption name={name} resetValue={validOptions} />;
}

function ResetSelectedOption({ name, resetValue }: { name: string; resetValue: any }) {
  const hasResetComponentLoaded = React.useRef(false);

  React.useEffect(() => {
    if (hasResetComponentLoaded.current) {
      return;
    }
    hasResetComponentLoaded.current = true;
  }, []);

  return hasResetComponentLoaded.current ? null : <ResetValue name={name} resetValue={resetValue} />;
}

function ResetValue({ name, resetValue }: { name: string; resetValue: any }) {
  const { setFieldValue } = useFormikContext();

  React.useEffect(() => {
    setFieldValue(name, resetValue);
  }, [name, resetValue, setFieldValue]);

  return null;
}
